import Breadcrumb from "./Breadcrumb";
import "./legal-pages.css";

export default function PrivacyPolicy() {
  return (
    <section className="oglitz-legal">
      <div className="oglitz-legal__container">
      <Breadcrumb current="Privacy Policy" />
        <h1 className="oglitz-legal__title">Privacy Policy</h1>
        <p className="oglitz-legal__updated">Last updated: 01 January 2026</p>

        <div className="oglitz-legal__content">
          <h2>1. Information We Collect</h2>
          <p>
            We may collect personal information such as name, email address,
            phone number, company details, and inquiry information when you
            contact us.
          </p>

          <h2>2. How We Use Information</h2>
          <p>
            Information is used to respond to inquiries, provide services,
            improve user experience, and meet legal obligations.
          </p>

          <h2>3. Cookies & Tracking</h2>
          <p>
            Our website may use cookies and analytics tools to understand user
            behavior and improve performance. You can manage cookie preferences
            through your browser.
          </p>

          <h2>4. Data Sharing</h2>
          <p>
            We do not sell or rent personal data. Information may be shared with
            trusted service providers or legal authorities when required.
          </p>

          <h2>5. Data Security</h2>
          <p>
            We use industry-standard security measures to protect your data.
            However, no method of transmission over the internet is completely
            secure.
          </p>

          <h2>6. Data Retention</h2>
          <p>
            Personal data is retained only as long as necessary to fulfill its
            intended purpose or comply with legal requirements.
          </p>

          <h2>7. Your Rights</h2>
          <p>
            You may request access, correction, or deletion of your data and
            withdraw consent at any time by contacting us.
          </p>

          <h2>8. Third-Party Services</h2>
          <p>
            We are not responsible for the privacy practices of third-party
            websites or tools linked from our site.
          </p>

          <h2>9. Children’s Privacy</h2>
          <p>
            Our services are not intended for individuals under the age of 13.
          </p>

          <h2>10. Contact</h2>
          <p>
            For privacy-related concerns, email <strong>info@oglitz.com</strong>
            .
          </p>
        </div>
      </div>
    </section>
  );
}
